import { carleadCreationGetInitialProps } from '@wkda/carlead-creation-components';
import {
  BaseConversationalLeadPage,
  CarleadHIWWhyChooseWkdaFaq,
  CarleadStepCompoundBuyCarConsent,
  MatomoHelmet,
} from '@wkda/marketing-components';

function CarleadCreation() {
  return (
    <>
      <MatomoHelmet />
      <BaseConversationalLeadPage
        content={CarleadHIWWhyChooseWkdaFaq}
        manualForm={<CarleadStepCompoundBuyCarConsent showHeadline={false} />}
        showTrustPilot={true}
        howItWorksShowCta={true}
      />
    </>
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
